import { Pitch } from "../types/StrikeZone";

export const getPitchType = (pitch: Pitch): string => {
  let type = !!pitch?.type ? pitch?.type : "";
  if (type === "Four-seam FB") {
    type = "4-Seam FB";
  } else if (type === "Two-seam FB") {
    type = "2-Seam FB";
  }
  return type;
};

export const getSpeed = (pitch: Pitch): string => (!!pitch?.speed ? `${Math.round(pitch.speed)}mph` : "");

export const getExitVelocity = (pitch: Pitch): string =>
  !!pitch?.exitVelocity ? `${Math.round(pitch.exitVelocity)}mph` : "";

export const getLaunchAngle = (pitch: Pitch): string =>
  !!pitch?.launchAngle ? `${Math.round(pitch.launchAngle)}°` : "";

export const InformationLabels = {
  empty: "",
  emptyData: " ",
  exitVelocity: "Exit Velocity",
  pitchSpeed: "Pitch Speed",
  launchAngle: "Launch Angle",
  pitchType: "Pitch Type",
};
